// Maps common terms to potentially relevant S2 illustrations.
export const illustrationAliases = {
  'again': ['Redo'],
  'alert': ['Warning'],
  'announcement': ['MegaphonePromote', 'MegaphonePromoteExpressive'],
  'applications': ['Apps'],
  'audio': ['Microphone', 'MicrophoneOff', 'Volume', 'VolumeOff', 'VolumeOne'],
  'award': ['Trophy'],
  'badge': ['Ribbon'],
  'bag': ['ShoppingCart'],
  'banner': ['Flag', 'FlagCheckmark', 'FlagCross'],
  'basket': ['ShoppingCart'],
  'bookmark': ['Star'],
  'call': ['Phone'],
  'caret': ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp'],
  'cart': ['ShoppingBag'],
  'caution': ['AlertNotice', 'FileAlert', 'Warning'],
  'chain': ['Link'],
  'chat': ['CommentText', 'NoComment', 'Prompt', 'Conversationbubbles'],
  'chevron': ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp'],
  'cog': ['GearSetting'],
  'computer': ['Desktop', 'Laptop', 'Server'],
  'confirm': ['Check'],
  'convert': ['Transform'],
  'cut': ['Crop'],
  'date': ['Calendar'],
  'delete': ['Trash'],
  'device': ['Tablet'],
  'diagram': ['ChartAreaStack', 'GraphBarChart', 'PieChart'],
  'directory': ['FolderClose', 'FolderOpen', 'FolderShared'],
  'dismiss': ['Close', 'FolderClose', 'LockClose', 'MailClose'],
  'document': ['FileAlert', 'FileImage', 'FileText', 'FileVideo', 'FileZip', 'NoFile', 'NoSharedFile'],
  'earth': ['Globe', 'GlobeGrid'],
  'edit': ['Pencil'],
  'email': ['MailClose', 'MailOpen'],
  'emoticon': ['Emoji160'],
  'envelope': ['MailClose', 'MailOpen'],
  'error': ['Bug'],
  'extension': ['Plugin'],
  'favorite': ['Heart', 'Star'],
  'file': ['Document'],
  'film': ['FileVideo', 'MovieCamera', 'Video', 'Exposure'],
  'find': ['NoSearchResults', 'Search'],
  'flag': ['ReportAbuse'],
  'flash': ['Bolt'],
  'funnel': ['Filter', 'Filters', 'NoFilter'],
  'gem': ['Diamond'],
  'glitter': ['Sparkles'],
  'graph': ['ChartAreaStack', 'GraphBarChart', 'PieChart'],
  'graphics': ['VectorDraw'],
  'hold': ['Pause'],
  'host': ['Server'],
  'house': ['Home'],
  'hue': ['Color'],
  'idea': ['Lightbulb', 'LightbulbRays'],
  'info': ['Data', 'DataAnalytics'],
  'information': ['Data', 'DataAnalytics'],
  'insect': ['Bug'],
  'internet': ['Browser', 'BrowserError', 'BrowserNotCompatible'],
  'issue': ['BrowserError', 'CloudStateError', 'Error'],
  'jewel': ['Diamond'],
  'label': ['Tag'],
  'lamp': ['Lightbulb', 'LightbulbRays'],
  'launch': ['Rocket'],
  'learning': ['Education'],
  'letters': ['CommentText', 'FileText', 'Text'],
  'lightning': ['Bolt'],
  'loudspeaker': ['MegaphonePromote', 'MegaphonePromoteExpressive'],
  'love': ['Heart'],
  'magnify': ['NoSearchResults', 'Search'],
  'map': ['Location'],
  'marker': ['Flag', 'FlagCheckmark', 'FlagCross', 'Pin'],
  'measure': ['Ruler'],
  'melody': ['MusicNote'],
  'message': ['CommentText', 'NoComment', 'Chatbubble', 'Conversationbubbles'],
  'money': ['Wallet'],
  'motion': ['Animation'],
  'mouse': ['Cursor'],
  'move': ['Translate'],
  'movie': ['FileVideo', 'Video'],
  'music': ['AudioWave'],
  'network': ['Cloud', 'CloudStateDisconnected', 'CloudStateError', 'CloudUpload'],
  'none': ['NoBrands', 'NoComment', 'NoComments', 'NoElements', 'NoFile', 'NoFilter', 'NoImage', 'NoLibraries', 'NoLibrariesBrands', 'NoReviewLinks', 'NoSearchResults', 'NoSharedFile'],
  'not': ['NoBrands', 'NoComment', 'NoComments', 'NoElements', 'NoFile', 'NoFilter', 'NoImage', 'NoLibraries', 'NoLibrariesBrands', 'NoReviewLinks', 'NoSearchResults', 'NoSharedFile'],
  'notification': ['Bell'],
  'online': ['Cloud', 'CloudStateDisconnected', 'CloudStateError', 'CloudUpload'],
  'pad': ['Tablet'],
  'page': ['Document'],
  'paint': ['Brush'],
  'palm': ['Hand'],
  'partition': ['Segmentation'],
  'person': ['User', 'UserAvatar', 'UserGroup'],
  'photo': ['AIGenerateImage', 'Camera', 'FileImage', 'Image', 'ImageStack', 'MovieCamera', 'NoImage', 'Exposure'],
  'picture': ['AIGenerateImage', 'Camera', 'FileImage', 'Image', 'ImageStack', 'MovieCamera', 'NoImage', 'Exposure'],
  'pin': ['Location'],
  'place': ['Location'],
  'pointer': ['Cursor'],
  'portfolio': ['Briefcase'],
  'post': ['CloudUpload', 'DropToUpload', 'Upload', 'Paperairplane'],
  'present': ['Gift'],
  'problem': ['BrowserError', 'CloudStateError', 'Error'],
  'profile': ['UserAvatar'],
  'purse': ['Wallet'],
  'question': ['HelpCircle', 'Prompt'],
  'quick': ['SpeedFast'],
  'reduce': ['Minimize'],
  'refresh': ['Update'],
  'remove': ['Trash'],
  'repeat': ['Redo'],
  'sack': ['ShoppingBag'],
  'safe': ['LockClose', 'LockOpen'],
  'save': ['Download'],
  'savings': ['PiggyBank'],
  'schedule': ['Calendar'],
  'script': ['CodeBrackets'],
  'seal': ['StampClone'],
  'secure': ['LockClose', 'LockOpen'],
  'security': ['LockClose', 'LockOpen'],
  'send': ['CloudUpload', 'DropToUpload', 'EmptyStateExport', 'ExportTo', 'Upload', 'Paperairplane'],
  'settings': ['GearSetting'],
  'share': ['EmptyStateExport', 'ExportTo', 'Paperairplane'],
  'shift': ['Translate'],
  'shop': ['Market'],
  'slice': ['Segmentation'],
  'smiley': ['Emoji160'],
  'song': ['MusicNote'],
  'sound': ['AudioWave', 'Microphone', 'MicrophoneOff', 'Volume', 'VolumeOff', 'VolumeOne'],
  'spaceship': ['Rocket'],
  'spin': ['RotateCCW', 'RotateCW'],
  'stars': ['Sparkles'],
  'start': ['Play', 'PlayTriangle'],
  'stop': ['Close', 'FolderClose', 'LockClose', 'MailClose', 'Pause'],
  'store': ['Market'],
  'study': ['Education'],
  'support': ['HelpCircle'],
  'tag': ['Mention'],
  'telephone': ['Phone'],
  'tick': ['Check'],
  'time': ['Clock'],
  'timer': ['Stopwatch'],
  'toggle': ['Switch'],
  'tote': ['ShoppingBag'],
  'trim': ['Crop'],
  'trolley': ['ShoppingCart'],
  'turn': ['RotateCCW', 'RotateCW'],
  'undo': ['Revert'],
  'url': ['Link'],
  'video': ['MovieCamera', 'Filmstrip', 'Play', 'PlayTriangle'],
  'volume': ['AudioWave'],
  'warning': ['AlertNotice', 'FileAlert'],
  'watch': ['Clock'],
  'web': ['Browser', 'BrowserError', 'BrowserNotCompatible'],
  'world': ['Globe', 'GlobeGrid'],
  'write': ['Pencil']
};
